import { Attachment, SendMessageFilled } from '@ixigo/icons';
import IconButton from '@ixigo/iui/IconButton';
import { ChangeEventHandler, KeyboardEventHandler, useEffect, useRef, useState } from 'react';
import { useConversation } from '../../contexts/conversation';
import { getFileType } from '../../utils/conversation';
import Uploader from '../Uploader';
import { UploadedFile } from '../Uploader/index.types';

function TextInput() {
    const textAreaRef = useRef<HTMLTextAreaElement>(null);
    const { conversation, sendMessage } = useConversation();
    const [value, setValue] = useState('');

    useEffect(() => {
        if (!textAreaRef.current) return;

        textAreaRef.current.style.height = '20px';
        textAreaRef.current.style.height = `${textAreaRef.current?.scrollHeight}px`;
    }, [value]);

    const onSubmit = () => {
        textAreaRef.current?.blur();

        if (value) {
            const messageParts = [
                {
                    isPrivate: false,
                    text: {
                        content: value,
                    },
                },
            ];

            sendMessage({ messageParts, input: value });
            setValue('');
        }
    };

    const onTextInput: ChangeEventHandler = (e) => {
        setValue((e.target as HTMLTextAreaElement).value);
    };

    const onKeyDown: KeyboardEventHandler<HTMLTextAreaElement> = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            onSubmit();
        }
    };

    const onUpload = (file: File, data: UploadedFile) => {
        const fileData = {
            name: file.name,
            size: file.size,
            type: getFileType(file.type),
            url: data.secure_url,
        };

        const messageParts = [
            {
                isPrivate: false,
                file: fileData,
            },
        ];

        sendMessage({ messageParts, input: fileData });
    };

    const allowAttachment = conversation?.isAgentActive && !value;

    return (
        <div className='flex gap-10 items-center w-full p-15 bg-charcoal z-50'>
            <div className='flex gap-10 items-center w-full border border-charcoal-100 rounded-30 overflow-hidden'>
                <textarea
                    className='w-full h-20 px-15 py-[13px] outline-none resize-none'
                    placeholder='Type your query here'
                    value={value}
                    onChange={onTextInput}
                    onKeyDown={onKeyDown}
                    ref={textAreaRef}
                />
                {allowAttachment && (
                    <IconButton color='neutral' variant='flat' className='mr-10 rounded-full'>
                        <Uploader label={<Attachment className='cursor-pointer' />} onUpload={onUpload} />
                    </IconButton>
                )}
            </div>
            <IconButton className='shrink-0 w-[35px] h-[35px] rounded-full' onClick={onSubmit}>
                <SendMessageFilled />
            </IconButton>
        </div>
    );
}

export default TextInput;
